import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Alerts from '../views/Alerts.vue'
import Base from '../views/Base.vue'
import Devices from '../views/Devices.vue'
import Login from '../views/Login.vue'
import Maps from '../views/Maps.vue'
import Reports from '../views/Reports.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/',
    name: 'base',
    component: Base,
    children: [
      {
        path: '/devices',
        name: 'devices',
        component: Devices,
      },
      {
        path: '/reports',
        name: 'reports',
        component: Reports,
      },
      {
        path: '/alerts',
        name: 'alerts',
        component: Alerts,
      },
      {
        path: '/maps',
        name: 'maps',
        component: Maps,
      },
    ],
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
